import { useState } from "react";
import { Card } from "react-bootstrap";
import { Row, Col, Form, Input, Select, Upload } from "antd";

import Button from "antd-button-color";

import "./style.css";

const genderList = [
  {
    value: "laki-laki",
    label: "Laki-laki",
  },
  {
    value: "perempuan",
    label: "Perempuan",
  },
];

const formImage = {
  file: {
    value: [
      {
        uid: "-1",
        name: "image.png",
        status: "done",
        url: "https://i.pravatar.cc/100?u=123",
      },
    ],
    isValid: true,
    message: null,
  },
};

const ProfileContainer = () => {
  const [avatar, setAvatar] = useState(formImage);

  const imageChangeHandler = ({ fileList: newFileList }) => {
    const data = {
      file: {
        value: [newFileList[newFileList.length - 1]],
        isValid: true,
        message: null,
      },
    };
    setAvatar(data);
  };

  return (
    <>
      <Card>
        <Card.Header className="bg-transparent">
          <Card.Title className="p-t-8 p-b-2">Detail Akun</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="text-center mb-5">
            <Upload
              accept="image/*"
              listType="picture-card"
              className="avatar-uploader"
              fileList={avatar.file.value}
              showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
            >
              {avatar.file.value.length >= 1 && null}
            </Upload>

            <Upload
              accept="image/*"
              customRequest={() => {}}
              showUploadList={false}
              onChange={imageChangeHandler}
            >
              <Button ghost type="dark">
                Ubah Foto
              </Button>
            </Upload>

            <br />
            <div className="text-muted text-center mx-auto mt-3" style={{ width: "18rem" }}>
              Besar file: maksimum 5 Megabytes. Ekstensi file yang diperbolehkan: .JPG .JPEG .PNG
            </div>
          </div>

          <Form layout="vertical">
            <Row gutter={[16, 16]}>
              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Form.Item label="Nama" className="mb-0">
                  <Input placeholder="Nama" />
                </Form.Item>
              </Col>

              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Form.Item label="Email" className="mb-0">
                  <Input placeholder="Email" />
                </Form.Item>
              </Col>

              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Form.Item label="Jenis Kelamin" className="mb-0">
                  <Select
                    // value={gender.value}
                    placeholder="Jenis Kelamin"
                    className="w-100 select-py-2"
                    // onChange={e => onChangeHandler(e, "gender")}
                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  >
                    {genderList.map((data) => (
                      <Select.Option value={data.value} key={data.value}>
                        {data.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                <Form.Item label="No. Telepon" className="mb-0">
                  <Input placeholder="Nomor Telepon" prefix="+62" />
                </Form.Item>
              </Col>

              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <Form.Item className="mb-0">
                  <Button type="dark">Simpan</Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

export default ProfileContainer;
